import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Avatar } from '@mui/material';
import { TwitterIcon, GithubIcon, LinkedinIcon, EnvelopeIcon } from '../atoms/Icon';
import Grid2 from '@mui/material/Unstable_Grid2';

function SocialIcons() {
  return (
    <Grid2 container spacing={{ sm: 2, md: 3 }} sx={{ marginBottom: "48px" }}>
      <Grid2 xsOffset={2} xs={2} smOffset={4} sm={1} sx={{ py: "8px" }}>
        <Link component="a" href="https://github.com/1987yama3/" target="_blank" sx={{ width: "40px", display: "block" }}>
          <Avatar sx={{ bgcolor: "white" }}>
            <GithubIcon />
          </Avatar>
        </Link>
      </Grid2>
      <Grid2 xs={2} sm={1} sx={{ py: "8px" }}>
        <Link component="a" href="https://twitter.com/SEM_Technology/" target="_blank" sx={{ width: "40px", display: "block" }}>
          <Avatar sx={{ bgcolor: "white" }}>
            <TwitterIcon />
          </Avatar>
        </Link>
      </Grid2>
      <Grid2 xs={2} sm={1} sx={{ py: "8px" }}>
        <Link component="a" href="https://www.linkedin.com/in/1987yama3/" target="_blank" sx={{ width: "40px", display: "block" }}>
          <Avatar sx={{ bgcolor: "white" }}>
            <LinkedinIcon />
          </Avatar>
        </Link>
      </Grid2>
      <Grid2 xs={2} sm={1} sx={{ py: "8px" }}>
        <Link component="a" href="https://sem-technology.info/contact/form/" target="_blank" sx={{ width: "40px", display: "block" }}>
          <Avatar sx={{ bgcolor: "white" }}>
            <EnvelopeIcon />
          </Avatar>
        </Link>
      </Grid2>
    </Grid2>
  )
}

function InternalLinks() {
  return (
    <>
      <Typography variant='body2' align='center' sx={{ marginTop: "16px", marginBottom: "16px" }}>
        <Link  href="/privacy/">プライバシーポリシー</Link>
      </Typography>
      <Typography variant='body2' align='center' sx={{ marginTop: "16px", marginBottom: "16px" }}>
        <Link href="/terms/">ご利用規約</Link>
      </Typography>
    </>
  )
}

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://sem-technology.info">
        SEM Technology
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

interface FooterProps {
  description: string;
  title: string;
}

export default function Footer(props: FooterProps) {
  const { description, title } = props;

  return (
    <Box component="footer" sx={{ bgcolor: 'background.paper', py: 6 }}>
      <Container maxWidth="lg">
        <SocialIcons />
        <InternalLinks />
        <Copyright />
      </Container>
    </Box>
  );
}